import createApi from 'api/createApi';
import qs from 'query-string';

const stringify = (body) => qs.stringify(body, { arrayFormat: 'bracket' });

export const tags = {
	kb__list: 'mw/kb/list',
	kb__delete: 'mw/kb/delete',
	kb__status__list: 'mw/kb/status/list',
	kb__detail: 'mw/kb/detail',
	kb__save: 'mw/kb/save',
	kb__tags__search: 'mw/kb/tags/search',
	kb__rate: 'mw/kb/rate',
	kb__comment: 'mw/kb/Comment',
	kb__post__comment: 'mw/kb/postComment',
	kb__parent: 'mw/kb/parent',
	kb__export: 'mw/kb/item/export',
	kb__folder__export: 'mw/kb/folder/export',
};

export const kbApi = createApi({
	reducerPath: 'mw/kbApi',

	endpoints: (builder) => ({
		kbList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/kb/list?${stringify(body)}`,
			}),
			providesTags: [tags.kb__list],
		}),
		kbDelete: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/kb/delete',
				body,
				jsonType: true,
			}),
			providesTags: [tags.kb__delete],
		}),
		kbStatusList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/kb/status/list?${stringify(body)}`,
			}),
			providesTags: [tags.kb__status__list],
		}),
		kbDetail: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/kb/detail?${stringify(body)}`,
			}),
			providesTags: [tags.kb__detail],
		}),
		kbSave: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/kb/save',
				body,
				jsonType: true,
			}),
			providesTags: [tags.kb__save],
		}),
		kbTagsSearch: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/kb/tags/search',
				body,
				jsonType: true,
			}),
			providesTags: [tags.kb__tags__search],
		}),
		kbRate: builder.mutation({
			query: ({ id, ...body }) => ({
				method: 'POST',
				url: `/mw/kb/${id}/rate`,
				body,
			}),
			providesTags: [tags.kb__rate],
			invalidatesTags: [tags.kb__detail],
		}),
		kbComment: builder.query({
			query: ({ id, ...body }) => ({
				method: 'GET',
				url: `/mw/kb/${id}/comment?${stringify(body)}`,
			}),
			providesTags: [tags.kb__comment],
		}),
		kbReply: builder.query({
			query: ({ id, commentId, ...body }) => ({
				method: 'GET',
				url: `/mw/kb/${id}/comment/${commentId}/replies?${stringify(body)}`,
			}),
			providesTags: [tags.kb__comment],
		}),
		kbPostComment: builder.mutation({
			query: ({ id, ...body }) => ({
				method: 'POST',
				url: `/mw/kb/${id}/comment`,
				body,
			}),
			providesTags: [tags.kb__post__comment],
			invalidatesTags: [tags.kb__comment],
		}),
		kbExport: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/kb/item/export',
				body,
				jsonType: true,
			}),
			providesTags: [tags.kb__export],
		}),
		kbFolderExport: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/kb/folder/export',
				body,
				jsonType: true,
			}),
			providesTags: [tags.kb__folder__export],
		}),
		kbAddParent: builder.mutation({
			query: ({ kbId, parentId }) => ({
				method: 'POST',
				url: `/mw/kb/${kbId}/parent/${parentId}`,
			}),
			invalidatesTags: [tags.kb__detail, tags.kb__parent],
		}),
		kbDeleteParent: builder.mutation({
			query: ({ kbId, parentId }) => ({
				method: 'DELETE',
				url: `/mw/kb/${kbId}/parent/${parentId}`,
			}),
			invalidatesTags: [tags.kb__detail, tags.kb__parent],
		}),
	}),
});

export const {
	kbList,
	kbDelete,
	kbStatusList,
	kbDetail,
	kbSave,
	kbTagsSearch,
	kbRate,
	kbComment,
	kbReply,
	kbPostComment,
	kbExport,
	kbFolderExport,
	kbAddParent,
	kbDeleteParent,
} = kbApi.endpoints;

export default kbApi;
